import CalendlyStatusOn from "../../../assets/images/calendly-on.webp"
import CalendlyStatusOff from "../../../assets/images/calendly-off.webp"

interface Props {
  on: boolean
}

const CalendlyStatus = ({ on }: Props) => (
  <>
    <img
      src={on ? CalendlyStatusOn : CalendlyStatusOff}
      alt="calendly integration status indicator"
      width={102}
      height={33}
    />
    <span role="status" aria-live="polite" className="sr-only">
      {on ? "Calendly integration is on" : "Calendly integration is off"}
    </span>
  </>
)

export default CalendlyStatus
